import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return { value: void 0, done: !0 }; } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable || "" === iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } throw new TypeError(_typeof(iterable) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { __awaiter } from "tslib";
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { Button } from 'panamera-react-ui';
import { getSimulationCL as simulate } from 'calculo-cuotas-frances';
import { EXPONEA_EVENT_TYPES, EXPONEA_USER_FLOW, PANAMERA } from "../../../Constants/exponeaLeads";
import DependencyManager from "../../../DependencyManager";
import { withComponentDependency } from "../../../ComponentDependency/withComponentDependency";
import withConfig from "../../../ComponentDependency/withConfig";
import { getAccessToken, postData, redirect, convertInstallentsData, setFinanceLimitsMX, setFinanceLimitsCL } from "../helpers/helpers";
import EMIChoicesContainer from "../EMIChoicesContainer/EMIChoicesContainer";
var css = {
  "container": "oalp-36nAB",
  "desktop": "oalp-3P1Gu",
  "mobile": "oalp-1WfjV",
  "title": "oalp-6Cxlv",
  "userDetailsForm__tncCheckbox": "oalp-5gK5P",
  "userDetailsForm__tncCheckbox__label": "oalp-1GpzE",
  "userDetailsForm__tncCheckboxbg": "oalp-_ewQ8",
  "userDetailsForm__wrapperDiv": "oalp-39xE3",
  "formWrapper": "oalp-3wK6_",
  "rangeSlider": "oalp-14TNi",
  "submitBtn": "oalp-2JMDz",
  "sliderContainerWrapper": "oalp-h-vya",
  "loanAmountWrapper": "oalp-yb_4I",
  "loanAmountLabel": "oalp-3iNFk",
  "loanAmountValue": "oalp-1XIvl",
  "carAmountSliderContainer": "oalp-1d2HK",
  "heading": "oalp-2eqEU",
  "amount": "oalp-1tUuz",
  "instructionTxt": "oalp-11GeU",
  "active": "oalp-2DAkM",
  "toolTip": "oalp-6XtiB",
  "sliderContainer": "oalp-3mdOZ",
  "emiContainer": "oalp-1uLWD",
  "thankYouWrapper": "oalp-1ag_I",
  "thankYouImg": "oalp-3-G0U",
  "thankYouTextWrapper": "oalp-c2De2",
  "thankYouTitle": "oalp-UEgH6"
};
import { DATE_FORMATS, formatDate } from "../../../Utils/DateHelper";
import { TRACKING_EVENTS } from "../../../Constants/trackingEvents";
import { ATTRIBUTE_VALUES, CF_PAGES, FLOW_TYPES, SLIDERS, CURRENCY_SYMBOLS } from "../../../Constants/finance";
import { getAcquisitionChannelTrackingValues } from "../../../Utils/LayoutHelper";
import { MOBILE } from "../../../Constants/platform";
import classNames from 'classnames';
var initialState = {
  carValue: 0,
  loanAmount: 0,
  activeSlider: SLIDERS.CAR
};
var initialLimits = {
  minCarValue: 0,
  maxCarValue: 0,
  minHitchPercentage: 0,
  maxHitchPercentage: 0,
  minLoanAmount: 0,
  sliderStep: 10000
};
export var CalculatorScreen = function CalculatorScreen(_ref) {
  var data = _ref.data,
    financeConfig = _ref.financeConfig,
    config = _ref.config,
    locale = _ref.locale,
    useConsumerFinanceLogic = _ref.useConsumerFinanceLogic,
    CarAmountSlider = _ref.CarAmountSlider,
    UserDataForm = _ref.UserDataForm,
    onTrack = _ref.onTrack,
    ThankYouWidget = _ref.ThankYouWidget,
    TnCCheckbox = _ref.TnCCheckbox,
    metadata = _ref.metadata,
    financeSetting = _ref.financeSetting,
    origin = _ref.origin,
    useLeadGeneration = _ref.useLeadGeneration;
  var _ref2 = data || {},
    step1 = _ref2.step1,
    step2 = _ref2.step2,
    handoverToClFlow = _ref2.handoverToClFlow,
    legal = _ref2.legal;
  var _ref3 = metadata || {},
    thankYouTitle = _ref3.thankYouTitle,
    thankYouSubtitle = _ref3.thankYouSubtitle;
  var _ref4 = step1 || {},
    title = _ref4.title,
    _ref4$labels = _ref4.labels,
    carValueLabels = _ref4$labels.carValue,
    hitchValueLabels = _ref4$labels.hitchValue,
    totalLoanAmount = _ref4$labels.totalLoanAmount,
    cta = _ref4$labels.cta;
  var PanameraConstants = DependencyManager.getDependency('constants');
  var financeLimits = useRef(initialLimits);
  var isMobile = PanameraConstants.platform === MOBILE;
  var financeMarketConfig = config.get('financeTabConfig');
  if (handoverToClFlow) {
    var _ref5 = financeSetting || {},
      _ref5$simulacion = _ref5.simulacion,
      simulacion = _ref5$simulacion === void 0 ? {} : _ref5$simulacion;
    var minLoanAmmount = financeConfig.minLoanAmmount;
    financeLimits.current = setFinanceLimitsCL(simulacion, financeMarketConfig);
    initialState.carValue = financeLimits.current.minCarValue;
    initialState.loanAmount = minLoanAmmount;
  } else {
    financeLimits.current = setFinanceLimitsMX(financeConfig, financeMarketConfig);
    initialState.carValue = financeLimits.current.minCarValue;
    initialState.loanAmount = financeConfig.minLoanAmmount;
  }
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    compState = _useState2[0],
    updateCompState = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    installmentData = _useState4[0],
    saveData = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    accessToken = _useState6[0],
    saveAccessToken = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    sessionId = _useState8[0],
    saveSessionId = _useState8[1];
  var showTnCCheckBox = useMemo(function () {
    return config.get('siteCode') === 'olxmx';
  }, [config]);
  var _useState9 = useState(!showTnCCheckBox),
    _useState10 = _slicedToArray(_useState9, 2),
    tncAccepted = _useState10[0],
    toggleTnc = _useState10[1];
  var onToggleTnC = useCallback(function () {
    toggleTnc(function (currentValue) {
      return !currentValue;
    });
  }, []);
  useEffect(function () {
    if (handoverToClFlow && config) {
      var apiUrl = config.get('financeSessionApi');
      getAccessToken(apiUrl).then(function (obj) {
        saveAccessToken(obj.accessToken);
        saveSessionId(obj.sessionId);
      });
    }
  }, [handoverToClFlow, financeConfig, financeLimits, config]);
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    calculatorScreenVisible = _useState12[0],
    handleCalculatorSubmit = _useState12[1];
  var prevHitchValue = useRef();
  var _useConsumerFinanceLo = useConsumerFinanceLogic({
      financeConfig: financeConfig,
      config: config,
      carValue: compState.carValue,
      currencySymbol: {
        pre: '$',
        post: '',
        iso_4217: 'USD',
        locale: 'en'
      },
      locale: locale,
      financeLimits: financeLimits.current,
      prevHitchValue: prevHitchValue,
      installments_Cl: installmentData.installments,
      handoverToClFlow: handoverToClFlow
    }),
    tncLink = _useConsumerFinanceLo.tncLink,
    minHitchAmount = _useConsumerFinanceLo.minHitchAmount,
    maxHitchAmount = _useConsumerFinanceLo.maxHitchAmount,
    hitchAmount = _useConsumerFinanceLo.hitchAmount,
    formattedLoanAmount = _useConsumerFinanceLo.formattedLoanAmount,
    repaymentPeriodCounts = _useConsumerFinanceLo.repaymentPeriodCounts,
    emi = _useConsumerFinanceLo.emi,
    selectedEMIChoice = _useConsumerFinanceLo.selectedEMIChoice,
    selectEMIChoice = _useConsumerFinanceLo.selectEMIChoice,
    loanAmount = _useConsumerFinanceLo.loanAmount;
  var setSelectFrom = function setSelectFrom(from) {
    return {
      select_from: from
    };
  };
  var getExponeaTrackingInfo = useCallback(function () {
    return {
      carPrice: compState.carValue,
      downPayment: hitchAmount,
      loanAmount: emi.amount,
      selectedInstallment: emi.repaymentPeriod,
      customerFlow: EXPONEA_USER_FLOW.FINANCE,
      generator: PANAMERA
    };
  }, [compState, hitchAmount, emi]);
  var getTrackingInfo = useCallback(function () {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var trackingInfo = Object.assign({
      item_price: compState.carValue,
      item_down_payment: hitchAmount,
      item_emi_amount: emi.amount,
      item_loan_duration: emi.repaymentPeriod,
      flow_type: FLOW_TYPES.HOME_CF,
      origin: origin
    }, getAcquisitionChannelTrackingValues());
    if (userId) {
      trackingInfo.user_id = userId;
    }
    return trackingInfo;
  }, [compState, hitchAmount, emi, origin]);
  var onSubmitTrack = function onSubmitTrack(_ref6) {
    var uid = _ref6.uid;
    if (onTrack) {
      onTrack(TRACKING_EVENTS.CF_LEAD_CREATED, Object.assign(Object.assign({}, getTrackingInfo(uid)), setSelectFrom(CF_PAGES.LEAD_GEN_FORM)));
    }
  };
  var _useLeadGeneration = useLeadGeneration({
      eventName: EXPONEA_EVENT_TYPES.CF_CONTACT_DATA,
      hitchAmount: hitchAmount.toString(),
      installmentPeriod: emi.repaymentPeriod.toString(),
      userFlow: EXPONEA_USER_FLOW.FINANCE,
      sitecode: config.get('siteCode'),
      optionalParams: {
        lastName: true,
        motherMaidenName: true,
        birthDate: true
      },
      onComplete: onSubmitTrack
    }),
    _useLeadGeneration2 = _slicedToArray(_useLeadGeneration, 11),
    _useLeadGeneration2$ = _slicedToArray(_useLeadGeneration2[0], 2),
    name = _useLeadGeneration2$[0],
    setName = _useLeadGeneration2$[1],
    _useLeadGeneration2$2 = _slicedToArray(_useLeadGeneration2[1], 2),
    email = _useLeadGeneration2$2[0],
    setEmail = _useLeadGeneration2$2[1],
    _useLeadGeneration2$3 = _slicedToArray(_useLeadGeneration2[2], 2),
    phone = _useLeadGeneration2$3[0],
    setPhone = _useLeadGeneration2$3[1],
    areAllUserValuesValid = _useLeadGeneration2[3],
    isPosting = _useLeadGeneration2[4],
    isCompleted = _useLeadGeneration2[5],
    onLeadSubmit = _useLeadGeneration2[6],
    isErr = _useLeadGeneration2[7],
    _useLeadGeneration2$4 = _slicedToArray(_useLeadGeneration2[8], 2),
    lastName = _useLeadGeneration2$4[0],
    setLastName = _useLeadGeneration2$4[1],
    _useLeadGeneration2$5 = _slicedToArray(_useLeadGeneration2[9], 2),
    motherMaidenName = _useLeadGeneration2$5[0],
    setMotherMaidenName = _useLeadGeneration2$5[1],
    _useLeadGeneration2$6 = _slicedToArray(_useLeadGeneration2[10], 2),
    birthDate = _useLeadGeneration2$6[0],
    setBirthDate = _useLeadGeneration2$6[1];
  useEffect(function () {
    prevHitchValue.current = hitchAmount;
  });
  var handleAttributeValueChange = useCallback(function (trackingData) {
    if (onTrack) {
      onTrack(TRACKING_EVENTS.CF_ATTRIBUTE_COMPLETE, Object.assign(Object.assign({}, getTrackingInfo()), trackingData));
    }
  }, [onTrack, getTrackingInfo]);
  function handleCarValueChange(carVal) {
    prevHitchValue.current = hitchAmount;
    updateCompState(Object.assign(Object.assign({}, compState), {
      carValue: carVal
    }));
    var trackingData = Object.assign({
      field_name: ATTRIBUTE_VALUES.CAR_VALUE,
      chosen_option: carVal,
      item_price: carVal
    }, setSelectFrom(CF_PAGES.CALCULATOR));
    handleAttributeValueChange(trackingData);
  }
  function hitchChangeHandler(hitchAmount) {
    prevHitchValue.current = hitchAmount;
    var loanAmount = compState.carValue - hitchAmount;
    updateCompState(Object.assign(Object.assign({}, compState), {
      loanAmount: loanAmount
    }));
    var trackingData = Object.assign({
      field_name: ATTRIBUTE_VALUES.DOWNPAYMENT,
      chosen_option: hitchAmount,
      item_down_payment: hitchAmount
    }, setSelectFrom(CF_PAGES.CALCULATOR));
    handleAttributeValueChange(trackingData);
  }
  function moveToNextStep() {
    if (onTrack) {
      var dependencyFunction = DependencyManager.getDependency('functions');
      if (dependencyFunction && dependencyFunction.exponeaTrack) {
        dependencyFunction.exponeaTrack(EXPONEA_EVENT_TYPES.FIN_CALCULATOR, Object.assign(Object.assign({}, getExponeaTrackingInfo()), setSelectFrom(CF_PAGES.CALCULATOR)));
      }
      onTrack(TRACKING_EVENTS.CF_TAP_REQUEST_CREDIT, Object.assign(Object.assign({}, getTrackingInfo()), setSelectFrom(CF_PAGES.CALCULATOR)));
      onTrack(TRACKING_EVENTS.CF_PAGE_OPEN, Object.assign(Object.assign({}, getTrackingInfo()), setSelectFrom(CF_PAGES.LEAD_GEN_FORM)));
    }
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
    handleCalculatorSubmit(false);
  }
  var tncClickHandler = useCallback(function () {
    if (onTrack) {
      onTrack(TRACKING_EVENTS.CF_TAP_TNC, Object.assign(Object.assign({}, getTrackingInfo()), setSelectFrom(CF_PAGES.LEAD_GEN_FORM)));
    }
  }, [onTrack, getTrackingInfo]);
  var getInstallmentData = useCallback(function (loanAmount) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var installments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            installments = simulate(loanAmount, financeSetting);
            _context.next = 3;
            return installments;
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [financeSetting]);
  useEffect(function () {
    if (handoverToClFlow && loanAmount) {
      getInstallmentData(loanAmount).then(function (obj) {
        saveData(obj);
      });
    }
  }, [loanAmount, handoverToClFlow, getInstallmentData]);
  useEffect(function () {
    if (onTrack) {
      onTrack(TRACKING_EVENTS.CF_PAGE_OPEN, Object.assign(Object.assign({}, getTrackingInfo()), setSelectFrom(CF_PAGES.CALCULATOR)));
    }
  }, []);
  function _handleSliderBeforeChange(slider) {
    updateCompState(Object.assign(Object.assign({}, compState), {
      activeSlider: slider
    }));
  }
  var replaceSessionIdInDataUrl = useCallback(function (apiUrl) {
    return apiUrl.replace('{sessionId}', sessionId);
  }, [sessionId]);
  var submitRedirect = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var simulations, person, apiUrl, redirectionUrl;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            simulations = [{
              id: null,
              carPrice: compState.carValue,
              cashPayment: hitchAmount,
              taxes: installmentData.taxes,
              charges: installmentData.charges,
              interestRate: installmentData.interestRate,
              results: installmentData.installments.map(function (_ref7) {
                var plan = _ref7.plan,
                  resultType = _ref7.type,
                  amount = _ref7.amount,
                  active = _ref7.active,
                  period = _ref7.period,
                  capitalBalance = _ref7.capitalBalance,
                  interestRate = _ref7.interestRate,
                  desgravamen = _ref7.desgravamen;
                return {
                  id: null,
                  selectedInstallment: false,
                  plan: plan,
                  resultType: resultType,
                  amount: amount,
                  active: active,
                  period: period,
                  capitalBalance: capitalBalance,
                  interestRate: interestRate,
                  desgravamen: desgravamen
                };
              })
            }];
            person = {
              email: email.val,
              phone: phone.val,
              name: name.val,
              fatherLastName: lastName.val,
              motherLastName: motherMaidenName.val,
              birthDay: formatDate(new Date(birthDate.val), DATE_FORMATS['YYYY-MM-DD'])
            };
            if (!config) {
              _context2.next = 8;
              break;
            }
            apiUrl = replaceSessionIdInDataUrl(config.get('financeDataApi'));
            redirectionUrl = config.get('financeSiteUrl');
            _context2.next = 7;
            return postData(accessToken, simulations, person, apiUrl);
          case 7:
            redirect(accessToken, redirectionUrl, sessionId);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }, [accessToken, compState, birthDate, hitchAmount, email, installmentData, lastName, motherMaidenName, name, phone, config, replaceSessionIdInDataUrl, sessionId]);
  var submitHandler = useCallback(function (event) {
    event.preventDefault();
    if (onTrack) {
      onTrack(TRACKING_EVENTS.CF_TAP_SUBMIT_LEAD, Object.assign(Object.assign({}, getTrackingInfo()), setSelectFrom(CF_PAGES.LEAD_GEN_FORM)));
    }
    onLeadSubmit(event);
    if (handoverToClFlow) {
      submitRedirect();
    }
  }, [onTrack, getTrackingInfo, onLeadSubmit, handoverToClFlow, submitRedirect]);
  function handleEmiChange(idx) {
    var loan = {};
    if (handoverToClFlow) {
      var _installmentData$inst = installmentData.installments,
        installments = _installmentData$inst === void 0 ? [] : _installmentData$inst;
      if (installments[idx]) {
        loan.amount = installments[idx].amount;
        loan.repaymentPeriod = installments[idx].plan;
      }
    } else if (repaymentPeriodCounts[idx]) {
      loan.amount = repaymentPeriodCounts[idx].emi;
      loan.repaymentPeriod = repaymentPeriodCounts[idx].repaymentPeriodCount;
    }
    var trackingData = {
      field_name: ATTRIBUTE_VALUES.LOAN_DURATION,
      chosen_option: loan.repaymentPeriod,
      select_from: CF_PAGES.CALCULATOR,
      item_loan_duration: loan.repaymentPeriod,
      item_emi_amount: loan.amount
    };
    handleAttributeValueChange(trackingData);
    selectEMIChoice(idx);
  }
  var renderUserFormData = useCallback(function () {
    return !handoverToClFlow && isCompleted ? /*#__PURE__*/React.createElement(ThankYouWidget, {
      title: thankYouTitle,
      subTitle: thankYouSubtitle,
      className: classnames(css.thankYouWrapper, css[PanameraConstants.platform]),
      imgClassName: css.thankYouImg,
      textClassName: css.thankYouTextWrapper,
      titleClassName: css.thankYouTitle
    }) : /*#__PURE__*/React.createElement(UserDataForm, {
      labelsData: step2,
      name: name.val,
      email: email.val,
      phone: phone.val,
      lastName: lastName.val,
      motherMaidenName: motherMaidenName.val,
      birthDate: birthDate.val,
      setLastName: setLastName,
      setMotherMaidenName: setMotherMaidenName,
      updateName: setName,
      updateEmail: setEmail,
      updatePhone: setPhone,
      isPosting: isPosting,
      handleFieldChange: handleAttributeValueChange,
      setBirthDate: setBirthDate,
      areAllUserValuesValid: areAllUserValuesValid,
      tncLink: tncLink,
      tncClickHandler: tncClickHandler,
      isErr: isErr
    });
  }, [areAllUserValuesValid, birthDate.val, email.val, isCompleted, isPosting, lastName.val, motherMaidenName.val, name.val, handleAttributeValueChange, phone.val, setBirthDate, setEmail, setLastName, setMotherMaidenName, setName, setPhone, step2, tncLink, thankYouSubtitle, thankYouTitle, PanameraConstants.platform, tncClickHandler, isErr, handoverToClFlow]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.container, css[PanameraConstants.platform])
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: submitHandler
  }, calculatorScreenVisible ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: classnames(css.title, css[PanameraConstants.platform])
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.formWrapper, css[PanameraConstants.platform])
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(css.sliderContainer, css.sliderContainerWrapper, _defineProperty({}, css.active, compState.activeSlider === SLIDERS.CAR))
  }, /*#__PURE__*/React.createElement(CarAmountSlider, {
    updateAmount: handleCarValueChange,
    minAmount: financeLimits.current.minCarValue,
    maxAmount: financeLimits.current.maxCarValue,
    amount: compState.carValue,
    locale: locale,
    currencySymbol: CURRENCY_SYMBOLS,
    heading: carValueLabels.heading,
    subHeading: carValueLabels.subHeading,
    cssClasses: {
      containerClass: css[PanameraConstants.platform],
      rangeSlider: css.rangeSlider,
      amount: css.amount,
      heading: css.heading,
      instructionTxt: css.instructionTxt,
      toolTip: css.toolTip
    },
    handleSliderBeforeChange: function handleSliderBeforeChange() {
      return _handleSliderBeforeChange(SLIDERS.CAR);
    },
    sliderStep: financeLimits.current.sliderStep
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.carAmountSliderContainer, css.sliderContainerWrapper, _defineProperty({}, css.active, compState.activeSlider === SLIDERS.HITCH))
  }, /*#__PURE__*/React.createElement(CarAmountSlider, {
    updateAmount: hitchChangeHandler,
    minAmount: minHitchAmount,
    maxAmount: maxHitchAmount,
    minAmountPercentage: financeLimits.current.minHitchPercentage,
    maxAmountPercentage: financeLimits.current.maxHitchPercentage,
    amount: hitchAmount,
    locale: locale,
    currencySymbol: CURRENCY_SYMBOLS,
    heading: hitchValueLabels.heading,
    subHeading: hitchValueLabels.subHeading,
    cssClasses: {
      containerClass: css[PanameraConstants.platform],
      rangeSlider: css.rangeSlider,
      amount: css.amount,
      heading: css.heading,
      instructionTxt: css.instructionTxt,
      toolTip: css.toolTip
    },
    handleSliderBeforeChange: function handleSliderBeforeChange() {
      return _handleSliderBeforeChange(SLIDERS.HITCH);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.loanAmountWrapper, css[PanameraConstants.platform])
  }, /*#__PURE__*/React.createElement("span", {
    className: css.loanAmountLabel
  }, totalLoanAmount), /*#__PURE__*/React.createElement("span", {
    className: css.loanAmountValue
  }, formattedLoanAmount)), /*#__PURE__*/React.createElement(EMIChoicesContainer, {
    repaymentPeriodCounts: handoverToClFlow ? convertInstallentsData(installmentData.installments) : repaymentPeriodCounts,
    selectedEMIChoice: selectedEMIChoice,
    selectEMIChoice: handleEmiChange,
    locale: locale,
    currencySymbol: CURRENCY_SYMBOLS,
    cssClasses: {
      containerClass: css.emiContainer
    }
  }), legal && /*#__PURE__*/React.createElement("div", {
    style: legal.style
  }, legal.text), showTnCCheckBox && /*#__PURE__*/React.createElement("div", {
    className: classNames(css.userDetailsForm__wrapperDiv, _defineProperty({}, css.userDetailsForm__tncCheckboxbg, isMobile))
  }, /*#__PURE__*/React.createElement(TnCCheckbox, {
    id: "userDetails_tncCheckbox",
    className: css.userDetailsForm__tncCheckbox,
    labelClassName: css.userDetailsForm__tncCheckbox__label,
    onChange: onToggleTnC
  })), /*#__PURE__*/React.createElement(Button, {
    className: css.submitBtn,
    type: "primaryBtn",
    size: "normal",
    htmlType: "submit",
    fixed: true,
    disabled: !(compState.carValue && tncAccepted),
    onClick: moveToNextStep
  }, /*#__PURE__*/React.createElement("span", null, cta)))) : renderUserFormData()));
};
export default compose(withComponentDependency, withConfig)(CalculatorScreen);